import Vue from 'vue'
import Router from 'vue-router'
import menuModule from 'vuex-store/modules/menu'
Vue.use(Router)

const scrollBehavior = (to, from, savedPosition) => {
  return new Promise(resolve => {
    this.app.$once('scrollAfterEnter', () => {
      if (savedPosition) {
        resolve(savedPosition)
      } else {
        resolve({ x: 0, y: 0 })
      }
    })
  })
}

export default new Router({
  mode: 'hash',
  linkActiveClass: 'is-active',
  scrollBehavior,
  routes: [
    {
      name: 'ProgressBar',
      path: '/progressBar',
      component: require('../views/progressBar')
    },
    {
      name: 'OnBoard',
      path: '/onBoard',
      component: require('../views/auth/OnBoard')
    },
    {
      name: 'OnBoardMember',
      path: '/onBoardMember/:userID',
      component: require('../views/auth/OnBoardMember')
    },
    {
      name: 'Login',
      path: '/login',
      component: require('../views/auth/Login')
    },
    {
      name: 'ForgotPassword',
      path: '/forgotPassword',
      component: require('../views/auth/ForgotPassword')
    },
    {
      name: 'Contact Us',
      path: '/contactUs',
      component: require('../views/contactUs/ContactUs')
    },
    {
      name: 'Terms of Service',
      path: '/terms',
      component: require('../views/terms/tos')
    },
    {
      name: 'Assessment Dashboard',
      path: '/home',
      component: require('../views/Home')
    },
    {
      name: 'Sample Meeting Agenda',
      path: '/agenda',
      component: require('../views/Agenda')
    },
    {
      name: 'My Change Risk Assessment',
      path: '/ChangeRiskAssessment',
      component: require('../views/assessment/riskAssessment')
    },
    {
      name: 'Account Setting',
      path: '/accountSetting',
      component: require('../views/accountSetting/AccountSetting')
    },
    {
      name: 'Manage Team Member(s)',
      path: '/teamInfo',
      component: require('../views/teamMember/teamMembers')
    },
    {
      name: 'Manage Assessment',
      path: '/assessmentInfo',
      component: require('../views/assessment/assessmentInfo')
    },
    {
      name: 'Reset Password',
      path: '/resetPassword/:token',
      component: require('../views/auth/ResetPassword')
    },
    {
      name: 'ChangeVU Admin',
      path: '/admin',
      component: require('../views/changeVuAdmin/admin')
    },
    ...generateRoutesFromMenu(menuModule.state.items),
    {
      path: '*',
      redirect: '/home'
    }
  ]
})

// Menu should have 2 levels.
function generateRoutesFromMenu (menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      routes.push(item)
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes)
    }
  }
  return routes
}



// WEBPACK FOOTER //
// ./client/router/index.js